import { BaseContactInfoSchema } from 'domains/signupDirect/schemas/common';
import { EmailSchema } from 'utils/validators/commonSchemas';
import { z } from 'zod';

export const resumeSignupLeadSchema = BaseContactInfoSchema.pick({
  phone: true,
}).extend({
  leadID: z.string(),
  email: EmailSchema,
});

export type ResumeSignupLeadFormType = z.infer<typeof resumeSignupLeadSchema>;
